import { Flex } from '@mantine/core';
import { GetKYCWorkflowRowRes } from '@dealstack/shared/lib/generated/models/GetKYCWorkflowRowRes';
import { StatusTooltipCount } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ManageInvestments/components/StatusTooltipCount.tsx';
import { DocumentStatusField, getDocumentItemCounts, visibleKycFileStatuses } from './utils.ts';

interface Props {
	workflows: GetKYCWorkflowRowRes[];
	field: DocumentStatusField;
}

export const DocumentStatusFooter = ({ workflows, field }: Props) => {
	const counts = getDocumentItemCounts(workflows, field);

	return (
		<Flex gap="0.5rem" wrap="wrap" align="center" h="100%">
			{visibleKycFileStatuses((status) => counts[status]).map((status) => (
				<StatusTooltipCount
					key={status}
					status={status}
					overrideCount={counts[status]}
					items={[]}
					isKyc
				/>
			))}
		</Flex>
	);
};
